import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal, Form, Input, Select, message } from 'antd';
import moment from 'moment';
import { DatePicker } from 'tdesign-react';
//mac
import { FaAppStore } from 'react-icons/fa';
// windows
import { AiFillWindows } from 'react-icons/ai';
// ios
import { BsApple, BsCpu } from 'react-icons/bs';
// Android
import { BsAndroid2 } from 'react-icons/bs';
// Harmony OS
import { SiHuawei } from 'react-icons/si';
import { RiDownloadLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';

import { PHONE_CODES } from '@src/consts/phone';
import countryList from '@src/consts/countryList';
import memberEnterprises from '@src/consts/memberEnterprises';
import { submitProblem } from '@src/services/downloadPage';
import { TIME_ZONES } from '@src/consts/timeZone';

import styles from './styles.module.less';

const DownloadPage = () => {
  const navigate = useNavigate();
  const formRef = useRef(null);

  const [problemVisible, setProblemVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [date, setDate] = useState(moment().format('YYYY-MM-DD HH:mm'));
  const [timeZoneData, setTimeZoneData] = useState({
    value: 8,
    text: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong",
    chinese: "（GMT+8:00）北京，珀斯，新加坡，香港"
  });
  const [tutorialVisible, setTutorialVisible] = useState(false);
  const [armVisible, setArmVisible] = useState(false);

  // Overseas APK 下载地址
  const OVERSEAS_APK_URL = 'https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas-V1.3.6-260604.apk';

  useEffect(() => {
    const timezoneOffset = new Date().getTimezoneOffset() / -60;
    const currentZone = TIME_ZONES.find(item => item.value === timezoneOffset) || {
      value: 8,
      text: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong",
      chinese: "（GMT+8:00）北京，珀斯，新加坡，香港"
    };
    setTimeZoneData(currentZone);
  }, []);

  useEffect(() => {
    if (problemVisible) setDate(moment().format('YYYY-MM-DD HH:mm'));
  }, [problemVisible]);

  const handleCancel = () => {
    setProblemVisible(false);
    setSubmitLoading(false);
  };

  const onFinish = async (data) => {
    if (moment(date).valueOf() > moment().valueOf()) {
      message.error('问题时间不能晚于当前时间');
      return;
    }
    setSubmitLoading(true);
    const res = await submitProblem({
      ...data,
      timeZone: timeZoneData.chinese,
      time: date
    });
    setSubmitLoading(false);
    if (res) {
      message.success('故障提交成功');
      handleCancel();
    }
  };

  const handleDownload = (href, fileName) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = href;
    if (fileName) downloadLink.download = fileName;
    downloadLink.click();
  };

  useEffect(() => {
    if (moment(date).valueOf() > moment().valueOf()) {
      formRef?.current?.setFields([{ name: 'time', errors: ['不得超过当前时间'] }]);
    } else {
      formRef?.current?.setFields([{ name: 'time', errors: '' }]);
    }
  }, [date]);

  const prefixSelector = (
    <Form.Item name="areaCode" noStyle rules={[{ required: true, message: "请选择国际编码" }]}>
      <Select placeholder="国际编码" style={{ width: 150 }}>
        {PHONE_CODES.map((item, index) => (
          <Select.Option value={item.value} key={index}>{item.text}</Select.Option>
        ))}
      </Select>
    </Form.Item>
  );

  return (
    <div className={styles.download_page}>
      {/* 故障提交 Modal */}
      <Modal
        title="在线提交客户端故障"
        open={problemVisible}
        onCancel={handleCancel}
        width={800}
        footer={null}
        destroyOnClose
      >
        <div className={styles.form_box}>
          <Form layout="vertical" onFinish={onFinish} ref={formRef}>
            <Form.Item
              label="成员企业名称"
              name="corporateName"
              rules={[{ required: true, message: "请选择成员企业名称" }]}
              style={{ width: '100%' }}
            >
              <Select placeholder="请选择成员企业名称" showSearch>
                {memberEnterprises.map((item, index) => (
                  <Select.Option value={item} key={index}>{item}</Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="您的称呼"
              name="userName"
              rules={[{ required: true, message: "请填写您的称呼" }]}
            >
              <Input placeholder="请填写您的称呼" />
            </Form.Item>

            <Form.Item
              label="您所在国家/地区"
              name="region"
              rules={[{ required: true, message: "请选择国家地区" }]}
            >
              <Select showSearch placeholder="请选择国家地区">
                {countryList.map((item, index) => (
                  <Select.Option key={index} value={item.chinese}>{item.chinese}</Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="邮箱地址"
              name="email"
              rules={[
                { required: true, message: "请填写邮箱地址" },
                { type: "email", message: "请输入正确的邮箱格式" }
              ]}
            >
              <Input placeholder="请填写邮箱地址" />
            </Form.Item>

            <Form.Item
              label="手机"
              name="phone"
              rules={[{ required: true, message: '请输入手机号码' }]}
            >
              <Input addonBefore={prefixSelector} placeholder="用于我们更快捷的联系到您" />
            </Form.Item>

            <Form.Item label="电建通账号" name="accountNumber">
              <Input placeholder="请填写您的电建通账号" />
            </Form.Item>

            <Form.Item
              label="接入方式"
              name="accessMode"
              initialValue="海外环网软件客户端"
              rules={[{ required: true, message: '请选择接入方式' }]}
            >
              <Select>
                <Select.Option value="海外环网软件客户端">海外环网软件客户端</Select.Option>
                <Select.Option value="海外环网SE1100硬件CPE">海外环网SE1100硬件CPE</Select.Option>
                <Select.Option value="海外环网SE2000硬件CPE">海外环网SE2000硬件CPE</Select.Option>
                <Select.Option value="海外环网SE500硬件CPE">海外环网SE500硬件CPE</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="问题出现时间" required>
              <div style={{ display: 'flex', gap: 12 }}>
                <Select
                  value={timeZoneData.chinese}
                  onChange={(val) => {
                    const currentTimeZone = TIME_ZONES.find(z => z.chinese === val) || timeZoneData;
                    setTimeZoneData(currentTimeZone);
                  }}
                  style={{ width: 180 }}
                >
                  {TIME_ZONES.map((item, index) => (
                    <Select.Option key={index} value={item.chinese}>{item.chinese}</Select.Option>
                  ))}
                </Select>
                <DatePicker
                  value={date}
                  onChange={setDate}
                  enableTimePicker
                  format="YYYY-MM-DD HH:mm"
                  disableDate={{ after: moment() }}
                  style={{ flex: 1 }}
                />
              </div>
            </Form.Item>

            <Form.Item
              label="问题描述"
              name="describe"
              rules={[{ required: true, message: "请填写问题描述" }]}
            >
              <Input.TextArea rows={4} placeholder="请输入您的问题，如：全球海外环网无法登录怎么办？" />
            </Form.Item>

            <div className={styles.form_footer_box}>
              <Button type="primary" ghost onClick={handleCancel}>取消</Button>
              <Button type="primary" htmlType="submit" loading={submitLoading}>确认</Button>
            </div>
          </Form>
        </div>
      </Modal>

      {/* 鸿蒙卓易通安装教程弹窗 */}
      <Modal
        title="鸿蒙卓易通安装教程"
        open={tutorialVisible}
        onCancel={() => setTutorialVisible(false)}
        footer={[<Button key="close" onClick={() => setTutorialVisible(false)}>关闭</Button>]}
        width={800}
        destroyOnClose
      >
        <div className={styles.tutorialContent}>
          <h3>📱 鸿蒙卓易通客户端安装指南</h3>
          <div className={styles.stepsContainer}>
            {/* 第一步 */}
            <div className={styles.stepItem}>
              <div className={styles.stepNumber}>第一步</div>
              <div className={styles.stepContent}>
                <p><strong>下载卓易通</strong> - 在鸿蒙设备上打开<strong>华为应用市场</strong>，搜索"卓易通"并下载安装</p>
                <div className={styles.stepImage}>
                  <img src="/image/zyt_step1.png" alt="下载卓易通" style={{ width: '100%' }} />
                </div>
              </div>
            </div>

            {/* 第二步 */}
            <div className={styles.stepItem}>
              <div className={styles.stepNumber}>第二步</div>
              <div className={styles.stepContent}>
                <p><strong>下载 Overseas 安装包</strong> - 使用浏览器打开以下地址：</p>
                <div className={styles.downloadLinkBox}>
                  <a
                    href={OVERSEAS_APK_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {OVERSEAS_APK_URL}
                  </a>
                </div>
                <div className={styles.stepImage}>
                  <img src="/image/zyt_step2.png" alt="浏览器下载安装包" style={{ width: '100%' }} />
                </div>
              </div>
            </div>

            {/* 第三步 */}
            <div className={styles.stepItem}>
              <div className={styles.stepNumber}>第三步</div>
              <div className={styles.stepContent}>
                <p><strong>通过卓易通安装</strong> - 打开卓易通 → "我的" → 文件互传 → "文件" → 找到下载的 Overseas 安装包，点击安装</p>
                <div className={styles.stepImage}>
                  <img src="/image/zyt_step3.png" alt="卓易通文件互传安装" style={{ width: '100%' }} />
                </div>
              </div>
            </div>

            {/* 第四步 */}
            <div className={styles.stepItem}>
              <div className={styles.stepNumber}>第四步</div>
              <div className={styles.stepContent}>
                <p><strong>登录拨号</strong> - 安装完成后，打开 Overseas，登录并进行拨号认证</p>
                <div className={styles.stepImage}>
                  <img src="/image/zyt_step4.png" alt="登录拨号" style={{ width: '100%' }} />
                </div>
              </div>
            </div>

            {/* 第五步 */}
            <div className={styles.stepItem}>
              <div className={styles.stepNumber}>第五步</div>
              <div className={styles.stepContent}>
                <p><strong>访问内部网络</strong> - 拨号成功后，即可通过浏览器访问内部网络</p>
                <div className={styles.stepImage}>
                  <img src="/image/zyt_step5.png" alt="访问内部网络" style={{ width: '100%' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Windows ARM 支持机型弹窗 */}
      <Modal
        title="Windows ARM版支持机型"
        open={armVisible}
        onCancel={() => setArmVisible(false)}
        footer={[<Button key="close" onClick={() => setArmVisible(false)}>关闭</Button>]}
        width={700}
        destroyOnClose
      >
        <div className={styles.arm_support_box}>
          <div className={styles.arm_tip}>
            本版本适用于 <b>ARM 架构</b> 的 Windows 电脑（搭载高通骁龙 Snapdragon 等 ARM 芯片）。
            可通过「任务管理器 → 性能 → CPU」查看是否显示“基于 ARM 的处理器”来判断。
          </div>
          <table className={styles.arm_table}>
            <thead>
              <tr>
                <th>品牌</th>
                <th>常见支持型号</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>微软 Surface</td>
                <td>Surface Pro X、Surface Pro 9 5G、Surface Pro 11、Surface Laptop 7</td>
              </tr>
              <tr>
                <td>联想 Lenovo</td>
                <td>ThinkPad X13s、ThinkPad X13 Gen 6、ThinkPad T14s Gen 6、Yoga Slim 7x</td>
              </tr>
              <tr>
                <td>三星 Samsung</td>
                <td>Galaxy Book Go、Galaxy Book2 Go、Galaxy Book4 Edge</td>
              </tr>
              <tr>
                <td>华为 Huawei</td>
                <td>MateBook E Go</td>
              </tr>
              <tr>
                <td>小米 Xiaomi</td>
                <td>小米 Book Air 13</td>
              </tr>
              <tr>
                <td>戴尔 Dell</td>
                <td>XPS 13（9345）、Inspiron 14（ARM）</td>
              </tr>
              <tr>
                <td>惠普 HP</td>
                <td>OmniBook X、Elite x2</td>
              </tr>
              <tr>
                <td>华硕 ASUS</td>
                <td>Vivobook S 15、ProArt PZ13</td>
              </tr>
              <tr>
                <td>宏碁 Acer</td>
                <td>Swift Go（ARM）</td>
              </tr>
            </tbody>
          </table>
          <div className={styles.arm_note}>
            注：以上为常见机型，其他 ARM 架构的 Windows 设备通常也可使用本版本。
          </div>
        </div>
      </Modal>

      {/* Banner 区域 */}
      <div className={styles.banner}>
        <div className={styles.logo}>
          <div>
            <img alt="" src="/image/logo6.png" />
          </div>
        </div>
        <div className={styles.center}>
          <div className={styles.title}>海外环网</div>
          <div className={styles.desc}>
            提供稳定、高速网络，并支持多软件客户端接入，全方位保障终端随时随地沟通协作，有效提高日常工作效率。
          </div>
          <div className={styles.footer_box}>
            <Button
              type="primary"
              onClick={() => handleDownload('/pdf/电建海外环网使用手册2024.pdf', '海外环网软件客户端操作手册.PDF')}
            >
              下载操作手册
            </Button>
            <Button type="primary" onClick={() => navigate('/problem')}>
              常见问题
            </Button>
            <Button type="primary" onClick={() => setProblemVisible(true)}>
              在线提交客户端故障
            </Button>
          </div>
        </div>
      </div>

      {/* 下载客户端区域 */}
      <div className={styles.content}>
        <div className={styles.heard_title}>|| 下载客户端</div>
        <ul>
          {/* Windows 版本 */}
          <li>
            <div className={styles.one}>
              <div className={styles.top}>
                <AiFillWindows />
              </div>
              <div className={styles.title}>Windows版本下载</div>
            </div>
            <div
              className={styles.two}
              onClick={() => {
                handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas-Windows-v2.13.25-20250925.zip');
              }}
            >
              <div className={styles.top}>
                <RiDownloadLine />
              </div>
              <div className={styles.title}>
                <span>Windows版本下载</span>
                <div className={styles.link_group}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas-Windows-v2.13.25-20250925.zip');
                    }}
                  >
                    国内下载
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas-Windows-v2.13.25-20250925.zip');
                    }}
                  >
                    海外下载
                  </span>
                </div>
              </div>
            </div>
          </li>

          {/* Windows ARM 版本 */}
          <li>
            <div className={styles.one}>
              <div className={styles.top}>
                <BsCpu />
              </div>
              <div className={styles.title}>Windows ARM版本下载</div>
            </div>
            <div
              className={styles.two}
              onClick={() => {
                handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/OverseasNet_2.18.02_arm.exe');
              }}
            >
              <div className={styles.top}>
                <RiDownloadLine />
              </div>
              <div className={styles.title}>
                <span>Windows ARM版</span>
                <div className={styles.link_group}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload('https://ulooclinet-beijing.oss-cn-beijing.aliyuncs.com/OverseasNet_2.18.02_arm.exe');
                    }}
                  >
                    国内下载
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/OverseasNet_2.18.02_arm.exe');
                    }}
                  >
                    海外下载
                  </span>
                </div>
                <div
                  className={styles.support_note}
                  onClick={(e) => {
                    e.stopPropagation();
                    setArmVisible(true);
                  }}
                >
                  点击查看支持机型 ≫
                </div>
              </div>
            </div>
          </li>

          {/* Mac 版本 */}
          <li>
            <div className={styles.one}>
              <div className={styles.top}>
                <FaAppStore />
              </div>
              <div className={styles.title}>Mac版本下载</div>
            </div>
            <div
              className={styles.two}
              onClick={() => {
                handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas%20Net_2.2.9_260506.dmg');
              }}
            >
              <div className={styles.top}>
                <RiDownloadLine />
              </div>
              <div className={styles.title}>
                <span>Mac版本下载</span>
                <div className={styles.link_group}>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas%20Net_2.2.9_260506.dmg');
                    }}
                  >
                    国内下载
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload('https://ulooclient.oss-cn-hongkong.aliyuncs.com/Overseas%20Net_2.2.9_260506.dmg');
                    }}
                  >
                    海外下载
                  </span>
                </div>
              </div>
            </div>
          </li>

          {/* iOS 版本 */}
          <li>
            <div className={styles.one}>
              <div className={styles.top}>
                <BsApple />
              </div>
              <div className={styles.title}>IOS版本下载</div>
            </div>
            <div className={styles.two}>
              <div className={styles.top}>
                <img src="/image/iosDowanLink.png" alt="" />
              </div>
              <div className={styles.title}>
                <span>IOS下载</span>
                <span>扫描二维码下载</span>
              </div>
            </div>
          </li>

          {/* Android 版本 */}
          <li>
            <div className={styles.one}>
              <div className={styles.top}>
                <BsAndroid2 />
              </div>
              <div className={styles.title}>Android下载</div>
            </div>
            <div className={styles.two}>
              <div className={styles.top}>
                <img src="/image/Android3Download-250220.png" alt="" />
              </div>
              <div className={styles.title}>
                <span>Android下载</span>
                <span>扫描二维码下载</span>
              </div>
            </div>
          </li>

          {/* 鸿蒙卓易通 - 只有安装教程按钮，无下载链接 */}
          <li>
            <div className={styles.one}>
              <div className={styles.top}>
                <SiHuawei />
              </div>
              <div className={styles.title}>鸿蒙卓易通版本</div>
            </div>
            <div
              className={styles.two}
              onClick={() => {
                setTutorialVisible(true);
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className={styles.top}>
                <RiDownloadLine />
              </div>
              <div className={styles.title}>
                <span>查看安装教程</span>
                <span
                  className={styles.tutorialBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    setTutorialVisible(true);
                  }}
                >
                  安装教程
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DownloadPage;